module.exports = __webpack_public_path__ + "static/media/order_confirmation_english_v2.0400eff2.png";